import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolusOption =
  | "standard" // Bolus (0)
  | "extended" // Bolex (1)
  | "quickbolus" // Quick (2)
  | "automated" // Closed loop, glycemia above 180 and not sleeping (3)
  | "ble_standard"; // ??? (4)

export type BolusRequested2Payload = {
  bolus_id: number;
  options?: number;
  standard_percent?: number;
  duration?: number;
  isf?: number;
  target_bg?: number;
  user_override?: number;
  declined_correction?: number;
};

export type BolusRequested2Event = {
  bolusId: number;
  bolusOption?: BolusOption;
  standardPercent?: number;
  duration?: number;
  isf?: number;
  targetBg?: number;
  userOverride?: number;
  declinedCorrection?: number;
};

const bolusRequested2Schema = z.object({
  bolus_id: z.number(),
  options: cz.permissive(z.number()),
  standard_percent: cz.permissive(z.number()),
  duration: cz.permissive(z.number()),
  isf: cz.permissive(z.number()),
  target_bg: cz.permissive(z.number()),
  user_override: cz.permissive(z.number()),
  declined_correction: cz.permissive(z.number()),
});

export const LID_BOLUS_REQUESTED_MSG2 = {
  value: 0x41,
  name: "Bolus Requested Event 2 of 3",
  format: "hbbh..hhbb..",
  fields: [
    "bolus_id",
    "options",
    "standard_percent",
    "duration",
    "isf",
    "target_bg",
    "user_override",
    "declined_correction",
  ],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    bolusOption: getBolusOption(rec.options),
    standardPercent: rec.standard_percent,
    duration: rec.duration ? rec.duration * 1000 : undefined,
    isf: rec.isf,
    targetBg: rec.target_bg,
    userOverride: rec.user_override,
    declinedCorrection: rec.declined_correction,
  }),
  schema: bolusRequested2Schema,
} as const satisfies TandemEventDefinition<BolusRequested2Payload, BolusRequested2Event>;

const getBolusOption = (bolusOption: number | undefined): BolusOption | undefined => {
  switch (bolusOption) {
    case 0:
      return "standard";
    case 1:
      return "extended";
    case 2:
      return "quickbolus";
    case 3:
      return "automated";
    case 4:
      return "ble_standard";
    default:
      return undefined;
  }
};
